module.exports = __webpack_public_path__ + "img/DE00705.72f6dbac.png";